"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeDrive1Client = void 0;
var blob_1 = require("../native/content/blob");
var drive_1 = require("./drive");
var settingsFactory_1 = require("./settingsFactory");
var cookie_1 = require("../http/authentication/cookie");
var axios_1 = require("../http/axios");
var factory_1 = require("./content/local/factory");
var http_1 = require("./client/http");
var errors_1 = require("../common/errors");
var factory_2 = require("./content/remote/factory");
var NativeDrive1Client = /** @class */ (function () {
    function NativeDrive1Client(settings, portalUserId, customHttpClient) {
        if (portalUserId === void 0) { portalUserId = ""; }
        var _a;
        this.portalUserId = portalUserId;
        var driveSettings = settings || settingsFactory_1.DriveSettingsFactory.getForDrive1();
        var authProvider = new cookie_1.CookieHttpAuthenticationProvider();
        var httpClient = customHttpClient || new axios_1.AxiosHttpClient(authProvider);
        var localContentFactory = new factory_1.NativeDriveLocalContentFactory();
        var driveHttpClient = new http_1.DriveHttpClient(driveSettings.apiUrl, (_a = driveSettings.clientIdentity) !== null && _a !== void 0 ? _a : "extern-core-js-native", httpClient);
        var remoteContentFactory = new factory_2.NativeDriveRemoteContentFactory(portalUserId, driveHttpClient, driveSettings);
        this.drive = new drive_1.Drive(driveSettings, localContentFactory, remoteContentFactory);
    }
    NativeDrive1Client.prototype.upload = function (file, options, token, progress) {
        var blobContent = new blob_1.BlobContent(file);
        if (!(options === null || options === void 0 ? void 0 : options.path) && !this.portalUserId) {
            throw new errors_1.CommonError("Cannot define the uploading path", null, errors_1.ErrorCodes.Mismatch);
        }
        return this.drive.upload(blobContent, options, token, progress);
    };
    NativeDrive1Client.prototype.getMetadata = function (url) {
        return this.drive.getMetadata(url);
    };
    return NativeDrive1Client;
}());
exports.NativeDrive1Client = NativeDrive1Client;
